import { render } from "./ChatGroupMessageThread.vue?vue&type=template&id=f62976f4&scoped=true"
import script from "./ChatGroupMessageThread.vue?vue&type=script&lang=js"
export * from "./ChatGroupMessageThread.vue?vue&type=script&lang=js"

import "./ChatGroupMessageThread.vue?vue&type=style&index=0&id=f62976f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62976f4"]])

export default __exports__